import { render, staticRenderFns } from "./RegularWidget.vue?vue&type=template&id=492941c8&"
import script from "./RegularWidget.vue?vue&type=script&lang=js&"
export * from "./RegularWidget.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./RegularWidget.vue?vue&type=style&index=0&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
